/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  dlsGray04, IconMenu, Navigation, NavigationItem, Tooltip, TooltipButton,
} from '@americanexpress/dls-react';
import OverflowItem from '../OverflowItem';
import { useEnhancedDataTableContext } from './EnhancedDataTableContext';
import itemActionListStyle from '../../styles/EnhancedTableToolbar/ItemActionList';

// Required Changes in Component to fix bugs discussed with Raju
const EnhancedTableRowItemActionList = React.memo(({
  row,
  rowKeyCol,
  handleActionItemClicked,
  handleRowCheckChange,
  isDisabled = false,
}) => {
  const context = useEnhancedDataTableContext();

  const [iconFilled, setIconFilled] = useState(false);

  const {
    tableNm,
    actionList,
  } = context;

  const onItemActionClickHandler = (actionId) => {
    handleActionItemClicked(actionId, [row]);
  };

  return (
    <div
      id={`${tableNm}-row-action-component`}
      style={{
        display: 'flex',
        justifyContent: 'space-around',
      }}
    >
      <OverflowItem
        labelComponent={(
          <Tooltip
            id={`${tableNm}-row-action-button-tooltip`}
            triggerElement={(
              <TooltipButton
                disabled={isDisabled}
                icon={<IconMenu size="md" theme={dlsGray04} title="Action List" filled={iconFilled} />}
                id={`${tableNm}-row-action-button`}
                onMouseOver={() => {
                  setIconFilled(true);
                }}
                onMouseOut={() => {
                  setIconFilled(false);
                }}
                onClick={(e) => {
                  handleRowCheckChange(e, {
                    id: row[rowKeyCol],
                    checked: row.selected,
                  });
                }}
              />
            )}
            placement="top"
            forcePlacement={true}
          >Action(s)
          </Tooltip>
        )}
        width="180"
        isLabelComponentClicked={row.selected}
        id={`${tableNm}-item-action-overflowItem`}
        isOutsideClick={true}
        isDisable={isDisabled}
        setLabelComponentClicked={(e) => {
          handleRowCheckChange(e, {
            id: row[rowKeyCol],
            checked: row.selected,
          });
        }}
      >
        {row.selected && (
          <Navigation
            aria-label="Popup Action List"
            id={`${tableNm}-item-action-navigation`}
            css={itemActionListStyle['.navigation']}
          >
            {actionList.map((item) => (
              <NavigationItem
                key={`${tableNm}-item-action-${item.id}`}
                id={`${tableNm}-item-action-${item.id}`}
                label={item.label}
                href=""
                onClick={() => onItemActionClickHandler(item.id)}
                theme={item.theme ? item.theme : itemActionListStyle['.navigationItem']}
                type="button"
              />
            ))}
          </Navigation>
        )}
      </OverflowItem>
    </div>
  );
});

EnhancedTableRowItemActionList.displayName = 'EnhancedTableRowItemActionList';

EnhancedTableRowItemActionList.propTypes = {
  handleActionItemClicked: PropTypes.func.isRequired,
  handleRowCheckChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
};

export default EnhancedTableRowItemActionList;
